import {observer} from 'mobx-react';
import NavigationIcon from 'main/components/navigation/index_table/NavigationIcon';
import CustomIcon from 'main/components/navigation/index_table/CustomIcon';
import ComponentIcon from 'main/components/navigation/index_table/ComponentIcon';
import PropTypes from 'prop-types';

const Icon = observer(({icon, trait = 'navigation'}) => {
  if (!icon) return null;

  switch (trait) {
    case 'navigation': return <NavigationIcon icon={icon}/>;
    case 'custom': return <CustomIcon icon={icon}/>;
    case 'component': return <ComponentIcon icon={icon}/>;
    default:
      throw new Error(`Trait ${trait} not supported.`);
  }
});

const IndexRowNameWithIcon = observer(({model}) => {
  return (
    <div>
      <Icon icon={model.icon} trait={model.trait} />
      <div className='table-cell align-top'>
        <p>{model.title}</p>
        {model.description && <p className='jumbo'>{model.description}</p>}
      </div>
    </div>
  );
});

Icon.propTypes = {
  trait: PropTypes.oneOf(['navigation', 'custom', 'component'])
};

export default IndexRowNameWithIcon;
